var map = {
	"./Bouquet.svg": 5945,
	"./HBD.svg": 6928,
	"./LED.svg": 2665,
	"./LED_Numbers_back.svg": 5704,
	"./fog_effect.svg": 3030,
	"./fog_effect_old.svg": 5440,
	"./hbdletters.svg": 5443,
	"./led_numbers.svg": 8454,
	"./party_props.svg": 2373,
	"./photoclippings.svg": 5263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 896;